import React from "react";
import { Button } from "aible";
import styles from "./style.module.css";

import Select from "react-select";

import { LineInput } from "components/Inputs/LineInput";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/aible/Dialog/Dialog";

const initState = {
  account: null,
  config: {
    azure_subscription_id: null,
    authorization_url: null,
    run_analysis_url: null,
    spark: {
      client_id: null,
      client_secret: null,
      azure_tenant: null,
      resource_id: null
    }
  },

  oa_change: false,
  or_change: false
};

const labelStyle = { paddingLeft: "10px" };
const inputStyle = { marginLeft: "auto", maxWidth: "400px", width: "inherit" };

export default class EditAccountModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = initState;
  }

  handleAccountChange(account) {
    this.setState({ account: account });
    account.value.configuration.azure_subscription_id
      ? this.setConfig("azure_subscription_id", account.value.configuration.azure_subscription_id)
      : this.setConfig("azure_subscription_id", null);

    account.value.configuration.authorization_url
      ? this.setConfig("authorization_url", account.value.configuration.authorization_url)
      : this.setConfig("authorization_url", null);

    this.setState({ oa_change: false });

    account.value.configuration.run_analysis_url
      ? this.setConfig("run_analysis_url", account.value.configuration.authorization_url)
      : this.setConfig("run_analysis_url", null);
    this.setState({ or_change: false });

    this.setConfig("client_id", null, true);
    this.setConfig("client_secret", null, true);
    this.setConfig("azure_tenant", null, true);
    this.setConfig("resource_id", null, true);
  }

  isButtonDisabled() {
    const { account, config } = this.state;

    return !(
      account &&
      config.azure_subscription_id &&
      config.authorization_url &&
      config.run_analysis_url &&
      config.spark.client_id &&
      config.spark.client_secret &&
      config.spark.azure_tenant &&
      config.spark.resource_id
    );
  }

  setConfig(prop, value, isSpark) {
    if (isSpark) {
      return this.setState((prevState) => {
        let config = { ...prevState.config };
        config["spark"][prop] = value;
        return { config };
      });
    }

    return this.setState((prevState) => {
      let config = { ...prevState.config };
      config[prop] = value;
      return { config };
    });
  }

  onAuthChange(val) {
    this.setConfig("authorization_url", val.trim());
    this.setState({ oa_change: true });
  }

  onRunChange(val) {
    this.setConfig("run_analysis_url", val.trim());
    this.setState({ or_change: true });
  }

  handleUpdate() {
    const { updateAccountConfig, setShowEditAccount } = this.props;

    const { account, config, oa_change, or_change } = this.state;

    if (!oa_change) {
      this.setConfig("authorization_url", account.value.configuration.authorization_url);
    }
    if (!or_change) {
      this.setConfig("run_analysis_url", account.value.configuration.run_analysis_url);
    }
    updateAccountConfig(account.value.id, config);
    this.setState(initState);
    setShowEditAccount(false);
  }

  render() {
    const { showModal, setShowEditAccount, accounts } = this.props;

    const { account, config, oa_change, or_change } = this.state;

    return (
      <Dialog open={showModal} onOpenChange={() => setShowEditAccount(false)}>
        <DialogContent>
          <DialogHeader className={styles.folderCreateModalHeader}>
            <DialogTitle>Edit Azure Accounts</DialogTitle>
          </DialogHeader>

          <span className={styles.editModalSelectLabel}>Select Account</span>
          <Select
            placeholder={"Select Account to Edit"}
            options={
              accounts
                ? accounts.map((a) => ({
                    label: a.name,
                    value: a
                  }))
                : []
            }
            value={account}
            onChange={(a) => this.handleAccountChange(a)}
          />
          {account && (
            <form>
              <LineInput
                isMediumBox
                inputStyle={inputStyle}
                label={"Azure Subscription ID"}
                labelStyle={labelStyle}
                placeholder={"Enter Azure Subscription ID"}
                value={config.azure_subscription_id ? config.azure_subscription_id : ""}
                onChange={(val) => val && this.setConfig("azure_subscription_id", val.trim())}
              />
              <LineInput
                isMediumBox
                inputStyle={inputStyle}
                label={"Authorization URL"}
                labelStyle={labelStyle}
                placeholder={"Enter authorization_url"}
                value={oa_change ? (config.authorization_url ? config.authorization_url : "") : "********"}
                onChange={(val) => val && this.onAuthChange(val)}
                isPassword
              />
              <LineInput
                isMediumBox
                inputStyle={inputStyle}
                label={"Run Analysis URL"}
                labelStyle={labelStyle}
                placeholder={"Enter run_analysis_url"}
                value={or_change ? (config.run_analysis_url ? config.run_analysis_url : "") : "********"}
                onChange={(val) => val && this.onRunChange(val)}
                isPassword
              />
              <LineInput
                isMediumBox
                inputStyle={inputStyle}
                label={"Application ID"}
                labelStyle={labelStyle}
                placeholder={"Enter Application ID"}
                value={config.spark.client_id ? config.spark.client_id : ""}
                onChange={(val) => val && this.setConfig("client_id", val.trim(), true)}
              />
              <LineInput
                isMediumBox
                inputStyle={inputStyle}
                label={"Application Password"}
                labelStyle={labelStyle}
                placeholder={"Enter Application Password"}
                value={config.spark.client_secret ? config.spark.client_secret : ""}
                onChange={(val) => val && this.setConfig("client_secret", val.trim(), true)}
                isPassword
              />
              <LineInput
                isMediumBox
                inputStyle={inputStyle}
                label={"Azure Tenant"}
                labelStyle={labelStyle}
                placeholder={"Enter Azure Tenant"}
                value={config.spark.azure_tenant ? config.spark.azure_tenant : ""}
                onChange={(val) => val && this.setConfig("azure_tenant", val.trim(), true)}
              />
              <LineInput
                isMediumBox
                inputStyle={inputStyle}
                label={"Resource ID"}
                labelStyle={labelStyle}
                placeholder={"Enter Resource ID"}
                value={config.spark.resource_id ? config.spark.resource_id : ""}
                onChange={(val) => val && this.setConfig("resource_id", val.trim(), true)}
              />
            </form>
          )}
          <DialogFooter>
            <Button onClick={() => this.handleUpdate()} disabled={this.isButtonDisabled()} type="primary">
              {"Update Account Configuration"}
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    );
  }
}
